require("../sass/style.scss");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");


(function ($) {
    $('.totop').click(function () {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 100) {
            $('header').addClass('fixed-header');
        } else {
            $('header').removeClass('fixed-header');
        }
    });

    $('.mobile-toggle-open').click(function () {
        $('.mobile-menu-in').toggleClass('visible');
    });


    if ($('.contacts-section').length > 0) {
        require("./custom/contact.es6");
    }

    if ($('.content_projects').length > 0) {
        require("./custom/project.es6");
    }

    if ($('.flex_slider').length > 0) {
        require("./custom/slider.es6");
    }

})(jQuery);